import { combineReducers } from "redux";
import customerReducer from "./customer/reducer";

const rootReducer = combineReducers({
    fraud: customerReducer,
});

export default rootReducer;
